import { useRef, useState } from "react";

import { IFeedEntry } from "../../store/FeedEntry";

import CardButtons from "../Card/Buttons";
import CardSourceInfo from "../Card/SourceInfo";
import RaisedContent from "../Card/RaisedContent";
import RaisedInfo from "../Card/RaisedInfo";

// import useIsInViewport from "../../store/useIsInViewport";
import CategoryHashtag from "../Card/CategoryHashtag";

interface CardWrapperProps {
  hidden: boolean;
  index: number;
  lastFeedIndex: number;
  feedEntry: IFeedEntry;
  taggedFeed: (category: string) => void;
  olderFeed: Function;
}

export default function CardWrapper(props: React.PropsWithChildren<CardWrapperProps>) {
  const elementRef = useRef<HTMLDivElement>(null);

  const [raiseContent, setContent] = useState(false);
  const [raiseInfo, setInfo] = useState(false);

  if (props.hidden) {
    return <div></div>;
  }

  const toggleContent = (): void => setContent(!raiseContent);
  const toggleInfo = (): void => {
    setInfo(!raiseInfo);
  };
  // snap-first snap-always md:h-3/4
  return (
    <div className="border-gray-800 border-b mb-3 pb-5 container flex flex-col md:mt-4 md:mb-4"> 
      <RaisedContent
        toggleContent={toggleContent}
        raised={raiseContent}
        content={props.feedEntry.content}
        title={props.feedEntry.title}
      />
      <div
        ref={elementRef}
        id={props.index.toString()}
        className="max-md:order-first"
      >
        {props.children}
      </div>
      <div style={{ height: "30%", paddingTop: "1em" }}>
        <div className="flex">
          <div className="flex-2">
            <CardSourceInfo
              feedEntry={props.feedEntry}
              toggleContent={toggleContent}
            ></CardSourceInfo>
          </div>
          <div
            className={
              (raiseInfo ? "dropdown-open " : "") +
              "flex-1 dropdown dropdown-top dropdown-end"
            }
          >
            <CardButtons toggleInfo={toggleInfo}></CardButtons>
            <RaisedInfo
              toggleInfo={toggleInfo}
              taggedFeed={props.taggedFeed}
              raised={raiseInfo}
              id={props.feedEntry.id}
              title={props.feedEntry.title}
              integration_object_id={props.feedEntry.integration_object_id}
              object_url={props.feedEntry.object_url}
              categories={props.feedEntry.integration_categories}
            />
          </div>
        </div>
        <div>
          <div className="py-2 px-4">
            <p className="text-md text-gray-500 dark:text-gray-400 overflow-hidden max-h-96 mb-1">
              {props.feedEntry.content}
            </p>
            <div>
              {props.feedEntry.categories &&
                props.feedEntry.categories.map(
                  (category: string, i: number) => {
                    return (
                      <CategoryHashtag
                        key={i}
                        category={category}
                        taggedFeed={(_ev: any, category: string) =>
                          props.taggedFeed(category)
                        }
                      />
                    );
                  }
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
